import { toast } from "sonner";
import { Download, FileText, ListChecks, BookOpen, FileBarChart, BookMarked } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import { Container, Reveal } from "@/components/Reveal";
import { RESOURCES } from "@/data/content";

const typeIcon = {
  Guide: BookOpen,
  Checklist: ListChecks,
  Reference: FileText,
  Whitepaper: BookMarked,
  "Case Study": FileBarChart,
};

export default function Resources() {
  const download = (title) =>
    toast.info(`"${title}" — download library launching soon.`, {
      description: "Contact us and we'll send it to you directly in the meantime.",
    });

  return (
    <>
      <SEO
        title="Resources"
        description="Downloadable guides, checklists, case studies, and whitepapers on commercial energy procurement and strategy."
        path="/resources"
      />
      <PageHero
        overline="Resources"
        titleLines={["Practical tools", "for smarter energy."]}
        subtitle="A curated library of guides, checklists, and case studies to support your commercial energy decisions."
        crumbs={[{ label: "Resources", path: "/resources" }]}
      />

      <section className="bg-white py-24 md:py-32">
        <Container>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {RESOURCES.map((r, i) => {
              const Icon = typeIcon[r.type] || FileText;
              return (
                <Reveal key={i} delay={(i % 3) * 0.07}>
                  <div className="flex h-full flex-col border border-line p-8 transition-colors hover:border-electric">
                    <div className="flex items-center justify-between">
                      <div className="flex h-12 w-12 items-center justify-center border border-line text-electric">
                        <Icon className="h-6 w-6" />
                      </div>
                      <span className="border border-line px-3 py-1 font-mono text-[10px] uppercase tracking-[0.14em] text-slatey">
                        {r.type}
                      </span>
                    </div>
                    <h3 className="mt-6 font-heading text-xl font-medium leading-snug text-navy">
                      {r.title}
                    </h3>
                    <p className="mt-3 flex-1 leading-relaxed text-slatey">{r.desc}</p>
                    <button
                      onClick={() => download(r.title)}
                      data-testid={`resource-download-${i}`}
                      className="group mt-7 inline-flex items-center gap-2 text-sm font-medium text-electric"
                    >
                      <Download className="h-4 w-4 transition-transform group-hover:translate-y-0.5" />
                      Download
                    </button>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </Container>
      </section>

      <CTABand
        heading="Need something specific?"
        text="Tell us what you're working on and we'll point you to the right resource — or build the analysis with you."
        secondary={{ label: "Education Center", to: "/education" }}
      />
    </>
  );
}
